"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.safeJsonStringify = exports.unleakString = void 0;
/**
 * This is to work around a chrome bug which can end up with large memory usage.
 * check out  https://bugs.chromium.org/p/v8/issues/detail?id=2869
 * and http://teams.microsoft.com/l/message/19:skypespaces_ddd88489c4064637ad2592915ee16e81@thread.skype/1520973359176?tenantId=72f988bf-86f1-41af-91ab-2d7cd011db47&groupId=af55e84c-dc67-4e48-9005-86e0b07272f9&parentMessageId=1520973359176&teamName=Microsoft%20Teams&channelName=Performance&createdTime=1520973359176
 * for the motivations behind this bug
 */
const unleakString = (str) => {
    if (str === null || str === undefined || str.length === 0) {
        return str;
    }
    return ` ${str}`.substr(1);
};
exports.unleakString = unleakString;
function safeJsonStringify(object, space) {
    // Handle the circular error by removing circular objects
    const cache = new WeakSet();
    return JSON.stringify(object, (_key, value) => {
        if (
        // We have already seen this object before
        cache.has(value)) {
            return undefined;
        }
        // Value is an object type
        if (value && typeof value === "object") {
            cache.add(value);
            // Special case handling for Maps and Sets
            // Maps and Sets aren't serializable. So we are going to
            // convert them to an array to serialize them
            if (value instanceof Map || value instanceof Set) {
                return Array.from(value);
            }
            if (value instanceof Error) {
                return `${value.name}: ${value.message}`;
            }
            // Value doesn't have a constructor or a prototype chain
            // This targets any `newable` objects. Anything that needs to be handled,
            // should be done above. This impacts custom classes, functions, derived classes.
            // Things like ArrayBuffer, Blob etc are also omitted as we don't know how to serialize them
            // without the proper mimetypes
            if ((value.constructor &&
                value.constructor !== Object &&
                value.constructor !== Array) ||
                value.prototype) {
                return;
            }
            // At this point, we just bleed into the next statement and let the default
            // stringification happen
        }
        // For everything else including primitives or objects that suit the criteria above
        return value;
    }, space);
}
exports.safeJsonStringify = safeJsonStringify;
